export function cleanHTML(
  html: string = '',
  tagsToClean: string[] = ['li', 'ul', 'p', 'b', 'strong', 'br']
): string {
  if (typeof window === 'undefined' || !html) return html

  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  tagsToClean.forEach(tag => {
    doc.querySelectorAll(tag).forEach(elem => {
      const text = (elem.textContent || '')
        .replace(/\u00A0/g, '')
        .trim()

      if (!text) {
        elem.remove()
      }
    })
  })

  return doc.body.innerHTML
}

export function cleanHTMLTags(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html')

  return doc.body.textContent?.trim() ?? ''
}
